import React, {
  Dispatch, ReactElement, SetStateAction, useEffect,
} from 'react';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { Button } from 'idsk-react-components';
import { useSuccessMessageContext } from '../../../../context/SuccessMessageContext';
import Uuid from '../../../../model/Uuid';
import { NotifikaciaTypEnum } from '../../../../model/notifikacia/NotifikaciaTyp';
import { useClient } from '../../../../context/ClientStatusContext';
import { sendNotification } from '../../../../client/admin/external/notifikaciaClient';

interface Props {
  confirmActionQuestion?: string;
  confirmActionDescription?: string;
  openButtonDescription?: string;
  reloadNotifikaciaHistoria?: () => void;
  className?: string;
  modalClass?: string;
  notificationType: NotifikaciaTypEnum,
  materialUuid: Uuid,
  setSendNotificationLoading: Dispatch<SetStateAction<boolean>>;
  setIsDropdownOpened: (isDropdownOpened: boolean) => void,
}

const NotifikaciaHistoriaDialog = ({
  confirmActionQuestion,
  confirmActionDescription,
  openButtonDescription,
  reloadNotifikaciaHistoria,
  className,
  modalClass,
  notificationType,
  materialUuid,
  setSendNotificationLoading,
  setIsDropdownOpened,
}: Props): ReactElement => {
  const {
    displaySuccess,
  } = useSuccessMessageContext();

  const {
    wrapClient: sendNotificationClient,
    status: sendNotificationStatus,
  } = useClient(sendNotification);

  const onSendNotification = async (): Promise<void> => {
    await sendNotificationClient(materialUuid, notificationType);
    reloadNotifikaciaHistoria();
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  useEffect(() => {
    setSendNotificationLoading(sendNotificationStatus.loading);
  }, [sendNotificationStatus, setSendNotificationLoading]);

  return (
    <ConfirmModal
      className={modalClass || ''}
      question={confirmActionQuestion}
      description={confirmActionDescription}
      cancelButtonText="Nie"
      confirmButton={
        (
          <Button
            buttonStyle="action"
            size="large"
          >
            Áno
          </Button>
        )
      }
      openButton={(
        <Button
          className={`notifikacia-historia__button ${className || ''}`}
          buttonStyle="link"
          size="small"
          onClick={() => {
            setIsDropdownOpened(false);
          }}
        >
          {openButtonDescription}
        </Button>
      )}
      doAfterConfirm={onSendNotification}
    />
  );
};

export default NotifikaciaHistoriaDialog;
